interface isElementOutOfViewportProps {
  containerElement?: HTMLElement
  innerElementHeight: number
  offset?: number
  top?: number
  bottom?: number
}

/**
 * Determines if an element is partially or fully out of the viewport.
 *
 * @param {HTMLElement} [props.containerElement] - The container element. If not provided, tries to use top and bottom props to manually get container size.
 * @param {number} props.innerElementHeight - The height of the inner element.
 * @param {number} [props.offset=0] - Additional offset to consider when checking visibility.
 * @param {number} [props.top=0] - Manual container positions.
 * @param {number} [props.bottom=0] - Manual container positions.
 * @returns {boolean} - True if the element is out of the viewport, false otherwise.
 */
export function isElementOutOfViewport({
  containerElement,
  innerElementHeight,
  offset = 0,
  top = 0,
  bottom = 0,
}: isElementOutOfViewportProps) {
  const containerRect = containerElement?.getBoundingClientRect()
  const viewportHeight = window.innerHeight

  const spaceBelow = viewportHeight - (containerRect?.bottom ?? bottom)

  if (spaceBelow >= innerElementHeight - offset) {
    return false
  }

  const spaceAbove = containerRect?.top ?? top
  if (spaceAbove >= innerElementHeight - offset) {
    return true
  }

  return spaceBelow > spaceAbove
}
